<template>
  <div data-app class="object-menu-container" :style="[xPosition, yPosition]">
    <div class="object-list-title">{{ $tc("SelectObject", 1) }}</div>

    <hr />

    <div class="list-container scroll-fire-fox">
      <join-cable-menu-item
        v-for="item in connections"
        :key="item.cb_id"
        :connection="item"
        @click="executeAction($event)"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import JoinCableMenuItem from "@/components/Home/Content/ObjectMenu/JoinCableMenu/JoinCableMenuItem";

export default {
  name: "JoinCableMenu",
  components: { JoinCableMenuItem },
  props: {
    coordinates: Array,
    connections: {
      type: Array,
      required: true
    },
    cableUuid: {
      type: String,
      required: true
    }
  },

  computed: {
    /**
     * Finds and stores the position where the object menu should be place in the x axis.
     *
     * @returns {{right: number}|{left: string}}
     * If the click on the map is in a coordinate that allows the menu to
     * appear entirely inside the screen, the menu is placed relatively to the left side of the parent element.
     * If the menu would not be able to be entirely contained in the screen, it is placed along the right side
     * of the map.
     */
    xPosition() {
      let parentWidth = this.$parent.$refs.map.offsetWidth;
      let totalWidth = this.coordinates[0] + 100;
      if (totalWidth < parentWidth) {
        return { left: this.coordinates[0] + "px" };
      } else {
        return { right: 0 };
      }
    },

    /**
     * Finds and stores the position where the object menu should be place in the y axis.
     *
     * @returns {{top: string}|{bottom: number}}
     * If the click on the map is in a coordinate that allows the menu to
     * appear entirely inside the screen, the menu is placed relatively to the top of the parent element.
     * If the menu would not be able to be entirely contained in the screen, it is placed along the bottom of the map.
     */
    yPosition() {
      let contentHeight = this.$parent.$refs.map.offsetHeight;
      let totalHeight = this.coordinates[1] + 168;
      if (totalHeight < contentHeight) {
        return { top: +this.coordinates[1] + "px" };
      } else {
        return { bottom: 0 };
      }
    }
  },

  methods: {
    ...mapActions(["joinCables"]),

    async executeAction(uuid) {
      this.$emit("closeMenu");
      try {
        if (!!uuid && !!this.cableUuid) {
          let data = { cable_a_uuid: this.cableUuid, cable_b_uuid: uuid };
          await this.joinCables(data);
          this.$toasted.global.toast_success(this.$i18n.t("JoinSuccess"));
        }
      } catch (e) {
        console.error(e);
        if (e.data && e.data[0]) {
          this.$toasted.global.toast_error(e.data[0]);
        }
      }
    }
  }
};
</script>

<style scoped>
.object-menu-container {
  position: absolute;
  z-index: 25;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  min-width: 140px;
  background-color: white;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.3);
}
.list-container {
  padding: 5px 0;
  max-height: 142px;
  overflow-y: auto;
}
.object-list-title {
  font-weight: bold;
  padding: 10px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectMenu/JoinCableMenu/JoinCableMenu.vue